import { useEffect, useState } from "react";
import { Box, IconButton, Slider, Tooltip } from "@material-ui/core";
import { FiltroRepPlano2DTO } from "../../models/controlls.model";
import RemoveCircleOutlineIcon from "@material-ui/icons/RemoveCircleOutline";

export default function RangoAñosC(props: rangoAñosCProps) {
  const [añoSelect, setAñosSelect] = useState([props.años[0], props.años[1]]);
  const campo = props.id.split("-")[0];
  const previousValue = props.previousValue;

  useEffect(() => {
    props.guardaSeleccion(campo ,creaFiltro());
    props.filtros[campo].valor = [añoSelect[0].toString(), añoSelect[1].toString()];
    props.filtros[campo].nombreColumna = props.nombreColumna;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [añoSelect]);

  function marks(): any[] {
    return [
      { value: props.años[0], label: props.años[0].toString() },
      { value: props.años[1], label: props.años[1].toString() },
    ];
  }

  function creaFiltro(): FiltroRepPlano2DTO {
    return {
      campo: campo,
      valor: [añoSelect[0].toString(), añoSelect[1].toString()],
      operador: "",
      filtro: props.filtro,
      nombreColumna: props.nombreColumna,
    };
  }

  const handleChangeSlider = (event: any, newValue: number | number[]) => {
    setAñosSelect(newValue as number[]);
  };

  const handleClickIco = (event: React.MouseEvent<HTMLButtonElement>) => {
    props.eliminaInput(props.id, props.filtro);
  };

  return (
    <Box sx={{ width: "93%", padding: "15px 15px 0px 15px" }}>
      <span>
        {`${campo} ${añoSelect[0]}-${añoSelect[1]}`}
        <Tooltip title="elimina campo">
          {!props.onlySentence ? (
            <>
              <IconButton
                id={`ico-${campo}`}
                aria-label="more"
                aria-controls="long-menu"
                aria-haspopup="true"
                onClick={handleClickIco}
              >
                <RemoveCircleOutlineIcon />
              </IconButton>
            </>
          ) : (
            <>
              <IconButton
                id={`ico-${campo}`}
                aria-label="more"
                aria-controls="long-menu"
                aria-haspopup="true"
                onClick={handleClickIco}
                style={{display: 'none'}}
              >
                <RemoveCircleOutlineIcon />
              </IconButton>
            </>
          )}
        </Tooltip>
      </span>
      <Slider
        getAriaLabel={() => "Rango de años"}
        value={añoSelect}
        onChange={handleChangeSlider}
        valueLabelDisplay="auto"
        // getAriaValueText={valuetext}
        marks={marks()}
        min={props.años[0]}
        max={props.años[1]}
        defaultValue={[props.años[0], props.años[1]]}
      />
    </Box>
  );
}

interface rangoAñosCProps {
  id: string;
  años: number[];
  filtro: boolean;
  filtros: any;
  ancho: number;
  onlySentence: boolean;
  nombreColumna: string;
  previousValue:any[];
  eliminaInput(idCampo: string, filtroInput: boolean): void;
  guardaSeleccion(campo: string , filtro: FiltroRepPlano2DTO): void;
}

RangoAñosC.defaultProps = {
  onlySentence: false,
  nombreColumna: '',
  previousValue:[]
};
